import instance from "../../axios";
import Axios from "../../axios";
import { ErrorHandler } from "../utils/ErrorHandler";

 const get = async (endPoint, params) => {
    try {
        const result = await instance.get(endPoint, { params: params });
        if (result.status === 200 || result.status === 206 || result.status === 202) return result.data;
        else throw result;
    } catch (e) {
        throw ErrorHandler(e);
    }
};

 const post = async (endPoint, data) => {
    try {
      console.log(data,'data');
      
        const result = await instance.post(endPoint, data);
        if (result.status === 200 || result.status === 206 || result.status === 202) return result.data;
        else throw result;
    } catch (e) {
        throw ErrorHandler(e);
    }
};

const put = async (endpoint, data) => {
  try {
    const result = await Axios.put(endpoint, data);
    if (result.status === 200) return result.data;
    else throw result;
  } catch (e) {
    throw ErrorHandler(e);
  }
};

 const patch = async (endPoint,data,param) => {
  console.log(param);
  
  try {
    const result = await Axios.patch(endPoint,data,{ params: param });
    if (result.status === 200) return result.data;
    else throw result;
  } catch (e) {
    throw ErrorHandler(e);
  }
};


const deleted = async (endpoint,param) => {
  console.log(param);
  
  try {
    const result = await Axios.delete(endpoint,{ params: param });
    if (result.status === 200) return result.data;
    else throw result;
  } catch (e) {
    throw ErrorHandler(e);
  }
}

export { get, post, put, patch, deleted };